import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Image from "../Tags/Image";
import Cookies from "js-cookie";
import { logOutUser } from "../../apis/user";
import { useMutation } from "react-query";
import { NavLink, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { fetchCsrfCookie } from "../../apis/csrf";
import { useCaptureEvent } from "../../hooks/useCaptureEvent";
import { LogOut, Sun } from "lucide-react";
import { useTheme } from "../ThemeProvider";
import useFeatureFlag from "../../hooks/useFeatureFlag";
import { getExtensionId } from "../../axios/constant";
function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function ProfileDropdown({ data, sidebarMini }) {
    const isBetaExtensionEnabled = useFeatureFlag("beta-extension");
  const { theme, setTheme } = useTheme();
  const navigate = useNavigate();
  const captureEvent = useCaptureEvent();
  const logOutUserFn = useMutation("logout", logOutUser, {
    onSuccess(data, variables, context) {
      // toast.success(data?.message);
      Cookies.remove(process.env.REACT_APP_PR_ACCESS_TOKEN);
      Cookies.remove(process.env.REACT_APP_PR_APP_SESSION_COOKIE);
      navigate("/login");
      if (typeof chrome !== "undefined" && chrome?.runtime?.sendMessage) {
        try {
          chrome.runtime.sendMessage(getExtensionId(), { type: "IS_BETA_USER", isBetaUser: isBetaExtensionEnabled }, () => {
            if (chrome.runtime.lastError) {
              console.log("Extension not available:", chrome.runtime.lastError.message);
            }
          });
        } catch (err) {
          console.error("Extension communication failed:", err);
        }
      }
    },
  });

  const handleLogout = () => {
    fetchCsrfCookie()
      .then((xsrfToken) => {
        logOutUserFn.mutate({});
      })
      .catch((error) => {
        console.error("Failed to fetch CSRF token:", error);
      });
  };

  return (
    <>
      {/* <div className="flex w-full justify-between pt-6 border-t border-t-border mt-6">
        <div className="inline-flex items-center">
          <Image nobaseurl src={data?.icon} width={32} height={32} className={"rounded-full mr-2"} />
          <span>
            <span className="text-gray-700 font-semibold"> {data?.name}</span>
            <span className="block text-[11px] text-gray-500 break-all">{data?.email}</span>
          </span>
        </div>
        <button
          onClick={() => {
            handleLogout();
            captureEvent("TOP_ThemeBtnTOP_UserProfileDropdown_LogOutBtn");
          }}
        >
          <LogOut width={20} height={20} className="text-gray-500" />
        </button>
      </div> */}
      <div className="flex w-full justify-between pt-6 border-t border-t-border mt-1">
        <Menu as="div" className="relative inline-block text-left">
          <div>
            <Menu.Button
              onClick={() => {
                captureEvent("TOP_UserProfileBtn");
              }}
            >
              <div className="inline-flex items-center text-left">
                <Image
                  nobaseurl
                  src={data?.icon}
                  width={32}
                  height={32}
                  className={`rounded-full mr-2 ${sidebarMini && "ml-2"}`}
                />
                {!sidebarMini && (
                  <span>
                    <span className="text-gray-700 font-semibold whitespace-pre"> {data?.name}</span>
                    <span className="block text-[11px] text-gray-500 break-all whitespace-pre">
                      {data?.email}
                    </span>
                  </span>
                )}
              </div>
            </Menu.Button>
          </div>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute bottom-full left-0 z-10 mb-2 w-56 origin-bottom-left rounded-md bg-background shadow-lg ring-1 ring-border ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  <NavLink
                    to={`/profile`}
                    className={"flex items-center space-x-3 w-full px-4 py-2 text-left"}
                    onClick={() => {
                      captureEvent("TOP_UserProfileDropdown_ProfileBtn");
                    }}
                  >
                    <Image
                      src="/images/icons/untitledui/user-2.svg"
                      alt=""
                      width="20"
                      className="sidebar__item__menu__icon"
                    />
                    <span> Account settings</span>
                  </NavLink>
                </Menu.Item>
                <Menu.Item>
                  <NavLink
                    onClick={() => {
                      if (theme === "light") {
                        setTheme("dark");
                      }
                      if (theme === "dark") {
                        setTheme("light");
                      }
                      captureEvent("TOP_ThemeBtn");
                    }}
                    className={"flex items-center w-full space-x-3 px-4 py-2 text-left"}
                  >
                    <Image src="/images/icons/untitledui/theme-icon.svg" alt="" width="20" />
                    {/* {theme === "light" && (
                    <span className="cursor-pointer transition-all text-text-700 mr-1">
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.3333 13.2035C17.2388 13.6985 16.0239 13.974 14.7446 13.974C9.92941 13.974 6.02597 10.0706 6.02597 5.25544C6.02597 3.97612 6.30151 2.76115 6.79648 1.66666C3.77147 3.03468 1.66667 6.07891 1.66667 9.61473C1.66667 14.4299 5.57012 18.3333 10.3853 18.3333C13.9211 18.3333 16.9653 16.2285 18.3333 13.2035Z"
                          stroke="currentColor"
                          stroke-width="1.66667"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  )}
                  {theme === "dark" && (
                    <Sun className="h-[1.25rem] w-[1.25rem] cursor-pointer transition-all mr-1" />
                  )} */}

                    <span>Toggle dark/light theme</span>
                  </NavLink>
                </Menu.Item>
                <div className="block w-full text-left border-t border-border mt-1">
                  <Menu.Item>
                    {({ active }) => (
                      <button
                        className={classNames(
                          active ? "bg-secondary" : "",
                          "flex w-full px-4 py-2 text-left"
                        )}
                        onClick={() => {
                          handleLogout();
                          captureEvent("TOP_ThemeBtnTOP_UserProfileDropdown_LogOutBtn");
                        }}
                      >
                        <LogOut width={20} height={20} className="text-gray-500 mr-3" />
                        Sign out
                      </button>
                    )}
                  </Menu.Item>
                </div>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </>
  );
}
